import React from "react";
import P from "../../shared/typography/P";

const InfoCard = ({ title, value, icon }) => {
    return (
        <div className="flex flex-col items-center justify-center">
            <div className="text-blue-500 bg-gray-200 p-1 rounded-2xl text-4xl mb-2">
                <img src={icon} alt={title} />
            </div>
            <P className="text-nowrap font-light">{title}</P>
            <p className="font-thin text-xs">{value}</p>
        </div>
    );
};

export default InfoCard;
